import { gameInfoType } from '@op/types/common';
import React, { useMemo, useState } from 'react';
import FilterInfo from './FilterInfo';
import GameComparisonTable from '../components/GameComparisonTable';
import GameComparisonChart from '../components/GameComparisonChart';
import { COMPARE_COLORS } from '../constant';
import { useMetricsChannel } from '@op/hooks/useMetricsChannel';
import './index.scss';
import HotContent from '../../ChannelShareRanking/HotContent';

export default function SameStartDate({
  gameInfo,
  userInfo,
  wholeGameInfo
}: {
  gameInfo: gameInfoType;
  userInfo: any;
  wholeGameInfo: any;
}) {
  const MergeChannelIconElement = useMetricsChannel({ gameInfo });
  const [selectedGameInfo, setSelectedGameInfo] = useState(null);
  const [showHotContent, setShowHotContent] = useState(false);

  function changeGameInfo(gameInfo: any) {
    setSelectedGameInfo(gameInfo);
    setShowHotContent(true);
  }

  function onClear() {
    setShowHotContent(false);
    setSelectedGameInfo(null);
  }

  return (
    <div className="dbo-same-start-date-wrapper">
      <FilterInfo userInfo={userInfo} gameInfo={gameInfo} wholeGameInfo={wholeGameInfo} onClear={onClear}>
        {({ filter, metrics, gameData, dateType, period, hotContentFilter }) => {
          const color = filter?.compare_games.reduce((acc, val, index) => {
            const { edition_unified_id, start_time, end_time } = val;
            const color =
              edition_unified_id === gameInfo?.edition_unified_id
                ? '#CB1000'
                : COMPARE_COLORS[index];
            const id = `${edition_unified_id}_${start_time}_${end_time}_${index}`;
            acc[id] = color;
            return acc;
          }, {});
          return (
            <>
              <div className='dbo-same-start-date'>
                <GameComparisonTable
                  filter={filter}
                  metrics={metrics}
                  gameData={gameData}
                  color={color}
                  gameInfo={gameInfo}
                  dateType={dateType}
                  showDate={period?.isPeriod ?? false}
                  MergeChannelIconElement={MergeChannelIconElement}
                  changeGameInfo={changeGameInfo}
                  selectedGameInfo={selectedGameInfo}
                />
                <div className={`dbo-same-start-date--right ${showHotContent ? '--show' : ''}`} >
                  <HotContent
                    onClear={onClear}
                    selectedGameInfo={selectedGameInfo}
                    filter={hotContentFilter}
                  ></HotContent>
                </div>
              </div>

              <GameComparisonChart
                filter={filter}
                metrics={metrics}
                gameData={gameData}
                dateType={dateType}
                color={color}
                gameInfo={gameInfo}
                singleTimeline
                period={period}
              />
            </>
          );
        }}
      </FilterInfo>
    </div>
  );
}
